<template>
  <div class="text-center mx-auto">
    <h1>Editando usuário | {{ user.name }}</h1>
    <v-divider></v-divider>
    <FormUser
      :user="user"
      :is-new="false"
      @submitUser="editUser($event)"
    ></FormUser>
    <v-dialog v-model="loading" persistent fullscreen>
      <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular
            indeterminate
            color="#00aab0"
            :size="100"
            :width="10"
          >
          </v-progress-circular>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FormUser from '@/pages/admin/components/user/FormUser';
import User from '@/models/user';
import AdminUserService from '@/services/admin-user/admin-user.service';

const adminUserService = new AdminUserService();

export default {
  name: 'EditUser',
  components: { FormUser },
  data: () => ({
    user: new User(),
    loading: false,
    snackbar: false,
    snackbarText: '',
  }),
  mounted() {
    const userId = this.$route.params?.userId ?? null;
    if (userId === null) {
      this.$router.push('/');
      return;
    }

    adminUserService.get(userId)
      .then((response) => {
        this.user.id = response.data.id;
        this.user.name = response.data.name;
        this.user.email = response.data.email;
        this.user.roles = response.data.roles;
        this.user.auth = response.data.auth;
      })
      .catch((err) => {
        this.showSnack(err?.response?.data?.message ?? 'Falha ao resgatar usuário');
      });
  },
  methods: {
    showSnack(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    editUser(user) {
      this.loading = true;

      adminUserService.updateUser(user)
        .then((response) => {
          this.showSnack(response.data.message);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.showSnack(err?.response?.data?.message ?? 'Falha ao atualizar usuário');
        });
    },
  },
};
</script>

<style scoped>

</style>
